/**
 * What the page says for a key the map server sends in an interaction's text in place of a sentence (ADR-120
 * decision 5.3's clause for the time before `interactionLine`; ADR-058's amendment of 2026-10-10, point 4): a locked
 * gate, a key spent on a gate that could not then open, and a gate that cannot place everyone standing in its gateway
 * (ADR-058's amendment of 2026-10-31, decision 6). Draft copy for the author. The file's name and a
 * value's name make the key the server sends (`thing.locked`).
 */
export const THING = {
  locked: "It is locked.",
  unlocked: "Unlocked.",
  stuck: "The gate won't budge.",
} as const;
